const animatedSections = (): void => {
  const animationReveal = (element: HTMLElement) => {
    const windowheight = window.innerHeight;
    const revealtop = element.getBoundingClientRect().top;
    const revealpoint = windowheight / 2;
    if (revealtop < windowheight - revealpoint) {
      element.classList.remove('animated-element--hidden');
    }
  };

  const animatedContentContainer =
    document.querySelectorAll('.animated-content');

  animatedContentContainer.forEach((container) => {
    const classes = container.getAttribute('class');
    const classesArr = classes.split(' ');
    const animatedClassPrefix = 'animate-class--';
    const animatedClassStr = classesArr.find((element) => {
      if (element.includes(animatedClassPrefix)) {
        return true;
      }
    });
    if (animatedClassStr) {
      const animatedClass = animatedClassStr.replace(animatedClassPrefix, '');
      const animatedElements = container.querySelectorAll('.' + animatedClass);
      animatedElements.forEach((element: HTMLElement) => {
        element.classList.add('animated-element', 'animated-element--hidden');
        document.addEventListener('scroll', () => {
          animationReveal(element);
        });
      });
    }
  });
};

export default animatedSections;
